import "./App.css";
import { useEffect, useState } from "react";
import Splash from "./components/splash/Splash";
import { Routes, Route, Router } from "react-router-dom";
import Selection from "./screens/selections/Selection";
import UploadImage from "./screens/upload-image/UploadImage";
import Dashboard from "./screens/dashboard/Dashboard";
import AreamMeasurement from "./screens/area/AreamMeasurement";
import Login from "./screens/auth/login/Login";
import Protected from "./components/protected/Protected";
import { useDispatch, useSelector } from "react-redux";
import { _authenticateUser } from "./redux/actions/authAction";
import NotFound from "./components/notFound/NotFound";
import AiScreen from "./screens/ai/AiScreen";
import AiResponseScreen from "./screens/ai-response-screen/AiResponseScreen";
import Test from "./screens/area/Test";

import "bootstrap/dist/css/bootstrap.min.css";
import Layout from "./components/resusable/layout/layout";
import Signup from "./screens/auth/signup/signup";
import ForgetPassword from "./screens/auth/forgetPassword/forgetPassword";
import ResetPassword from "./screens/auth/resetPassword/resetPassword";
import OtpScreen from "./screens/auth/otp/otpScreen";
import UpdatePassword from "./screens/settings/update-password/updatePassword";
import UpdateProfile from "./screens/settings/update-profile/updateProfile";
import SubscriptionsPlan from "./screens/subscriptions/subscriptions-plan";
import SubscribeConfirmation from "./screens/subscriptions/subscribe-confirmation";
import SubscribeCancellation from "./screens/subscriptions/subscribe-cancellation";
import ContactUs from "./screens/contact-us/contact-us";
import DentalIdentificationRoutes from "./dentail-indetifcation/DentalIdentificationRoutes";
import { _onClearDentalRecordData } from "./redux/actions/dentalRecordAction";
import useToggleSideMenu from "./hooks/useToggleSideMenu";
import AgeAssessmentRoutes from "./age-assessment/AgeAssessmentRoutes";
import Subscriptions from "./subscriptions/Subscriptions";
import StripePricingTable from "./subscriptions/strip/StripePricingTable";
import SubscriptionExpired from "./subscriptions/SubscriptionExpired";
import UpdateWorkSpace from "./screens/settings/update-profile/UpdateWorkspace";
import { useUserProfileRefresher } from "./hooks/subscription-hook/useUserProfileRefresher";
import ImageAnalysisProjects from "./image-analysis-tool/pages/projects-list/ImageAnalysisProjects";
import DentalMeasuremntTool from "./image-analysis-tool/pages/dental-measuremnt-tool/DentalMeasuremntTool";

function App() {
  useUserProfileRefresher();
  const [loading, setLoading] = useState(true);

  const isLoggin = useSelector((state) => state.auth.isLoggin);
  const dispatch = useDispatch();
  useToggleSideMenu();

  useEffect(() => {
    checkIfUserIsAthinticate();
  }, []);

  const checkIfUserIsAthinticate = () => {
    dispatch(_onClearDentalRecordData());
    const userdata = JSON.parse(localStorage.getItem("user"));
    if (userdata !== null) {
      dispatch(_authenticateUser(true));
    } else {
      dispatch(_authenticateUser(false));
    }
  };

  useEffect(() => {
    setTimeout(() => {
      setLoading(false);
    }, 2000);
  }, []);

  if (loading) {
    return <Splash />;
  }
  return (
    <Routes>
      <>
        <Route path="/login" element={<Login />} />
        <Route path="/sign-up" element={<Signup />} />
        <Route path="/forget-password" element={<ForgetPassword />} />
        <Route path="/add-otp" element={<OtpScreen />} />
        <Route path="/reset-password" element={<ResetPassword />} />
      </>

      <>
        <Route
          path="/"
          element={
            <Protected isLoggedIn={isLoggin}>
              <Selection />
              {/* <Layout/> */}
            </Protected>
          }
        />
        <Route
          path="/uploadImage"
          element={
            <Protected isLoggedIn={isLoggin}>
              <UploadImage />
            </Protected>
          }
        />
        <Route
          path="/contact-us"
          element={
            <Protected isLoggedIn={isLoggin}>
              <ContactUs />
            </Protected>
          }
        />
        <Route
          path="/dental-analysis/projects"
          element={
            <Protected isLoggedIn={isLoggin}>
              <ImageAnalysisProjects />
            </Protected>
          }
        />
        <Route
          path="/dental-analysis/projects/:id"
          element={
            <Protected isLoggedIn={isLoggin}>
              <DentalMeasuremntTool />
            </Protected>
          }
        />
        {/* TODO: Will be archieved latter */}
        <Route
          path="/length-measurement"
          element={
            <Protected isLoggedIn={isLoggin}>
              <Dashboard />
            </Protected>
          }
        />
        <Route
          path="/area-measurement"
          element={
            <Protected isLoggedIn={isLoggin}>
              <AreamMeasurement />
            </Protected>
          }
        />
        <Route
          path="/ai-measurement"
          element={
            <Protected isLoggedIn={isLoggin}>
              <AiScreen />
            </Protected>
          }
        />
        <Route
          path="/ai-measurement/result"
          element={
            <Protected isLoggedIn={isLoggin}>
              <AiResponseScreen />
            </Protected>
          }
        />
        <Route
          path="/update-password"
          element={
            <Protected isLoggedIn={isLoggin}>
              <UpdatePassword />
            </Protected>
          }
        />
        <Route
          path="/update-profile"
          element={
            <Protected isLoggedIn={isLoggin}>
              <UpdateProfile />
            </Protected>
          }
        />
        <Route
          path="/update-workspace"
          element={
            <Protected isLoggedIn={isLoggin}>
              <UpdateWorkSpace />
            </Protected>
          }
        />
        <Route
          path="/subscriptions-plan"
          element={
            <Protected isLoggedIn={isLoggin}>
              <SubscriptionsPlan />
            </Protected>
          }
        />
        <Route
          path="/subscription-expired"
          element={
            <Protected isLoggedIn={isLoggin}>
              <SubscriptionExpired />
            </Protected>
          }
        />
        <Route
          path="/subscribe/confirmation"
          element={
            <Protected isLoggedIn={isLoggin}>
              <SubscribeConfirmation />
            </Protected>
          }
        />
        <Route
          path="/subscribe/cancellation"
          element={
            <Protected isLoggedIn={isLoggin}>
              <SubscribeCancellation />
            </Protected>
          }
        />
        <Route
          path="/subscription"
          element={
            <Protected isLoggedIn={isLoggin}>
              <Subscriptions />
            </Protected>
          }
        />
        {/* <Route
          path="/subscription-pricing"
          element={
            <Protected isLoggedIn={isLoggin}>
              <StripePricingTable />
            </Protected>
          }
        />  */}
        {/* <Route
          path="/test"
          element={
            <Protected isLoggedIn={isLoggin}>
              <Test />
            </Protected>
          }
        /> */}
        <Route path="*" element={<NotFound />} />
        {/* Dental Identification Module */}
        <Route
          path="/dental-identification/*"
          element={
            <Protected isLoggedIn={isLoggin}>
              <DentalIdentificationRoutes />
            </Protected>
          }
        />{" "}
        <Route
          path="/age-assessment/*"
          element={
            <Protected isLoggedIn={isLoggin}>
              <AgeAssessmentRoutes />
            </Protected>
          }
        />{" "}
      </>
    </Routes>
  );
}

export default App;
